/**
 * Kratome — scroll-linked progress for .timeline (process/quality-journey sections).
 * The rail fill grows and each step lights up as it crosses a fixed line in
 * the viewport, so the timeline advances step by step as the visitor scrolls.
 */
(function () {
  "use strict";

  function init() {
    var timelines = document.querySelectorAll(".timeline");
    if (!timelines.length) return;

    var reduceMotion =
      window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (reduceMotion) {
      timelines.forEach(function (timeline) {
        var fill = timeline.querySelector(".timeline__rail-fill");
        if (fill) fill.style.height = "100%";
        timeline.querySelectorAll(".timeline__item").forEach(function (item) {
          item.classList.add("is-active");
        });
      });
      return;
    }

    var ticking = false;

    function update() {
      ticking = false;
      var triggerY = window.innerHeight * 0.55;

      timelines.forEach(function (timeline) {
        var rail = timeline.querySelector(".timeline__rail");
        var fill = timeline.querySelector(".timeline__rail-fill");
        if (!rail || !fill) return;

        var railRect = rail.getBoundingClientRect();
        var progress = (triggerY - railRect.top) / railRect.height;
        progress = Math.max(0, Math.min(1, progress));
        fill.style.height = progress * 100 + "%";

        timeline.querySelectorAll(".timeline__item").forEach(function (item) {
          var marker = item.querySelector(".timeline__number") || item;
          var markerRect = marker.getBoundingClientRect();
          var markerCenter = markerRect.top + markerRect.height / 2;
          item.classList.toggle("is-active", markerCenter <= triggerY);
        });
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    update();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
